// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * ReduceState class is an abstraction class.
 * It provide redux like mechanism.
 * You should override `reduce(payload): ReduceState`.
 */
var ReduceState = (function () {
    function ReduceState() {
    }
    /**
     * Compare `this` properties and `targetState` properties
     * If all properties is matched, return true.
     * @param {ReduceState} targetState
     * @returns {boolean}
     */
    ReduceState.prototype.equals = function (targetState) {
        var _this = this;
        if (this === targetState) {
            return true;
        }
        return Object.keys(this).every(function (key) {
            return _this[key] === targetState[key];
        });
    };
    /**
     * It default `reduce` method.
     * The `reduce` method should be override by inherited state.
     * @param {Object} payload
     * @returns {ReduceState}
     */
    ReduceState.prototype.reduce = function (payload) {
        switch (payload.type) {
            default:
                return this;
        }
    };
    return ReduceState;
}());
exports.ReduceState = ReduceState;
//# sourceMappingURL=ReduceState.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-reduce-store/lib/ReduceState.js
// module id = 232
// module chunks = 0